import React from "react";
import { TailSpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import "./Loader.css";

const Loader = () => {
  const isLoading = useSelector((state) => state.loader.loading);

  if (!isLoading) return null; 

  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <TailSpin height="80" width="80" color="#ffffff" ariaLabel="loading" />
      </div>
    </div>
  );
};

export default Loader;
